import { render } from "./RankingGainersLosers.vue?vue&type=template&id=639c47c2"
import script from "./RankingGainersLosers.vue?vue&type=script&lang=js"
export * from "./RankingGainersLosers.vue?vue&type=script&lang=js"

import "./RankingGainersLosers.vue?vue&type=style&index=0&id=639c47c2&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__